import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {FileUploadModule} from 'primeng/primeng';
import {TooltipModule} from 'primeng/primeng';
import {DialogModule} from "primeng/dialog";
import {MessagesModule} from "primeng/primeng";
import {MessageModule} from "primeng/primeng";

import {usersRouting} from './users.routing'

import {UserListComponent} from './user-list.component';
import {UserFormComponent} from './user-form.component';

import {ImageEditorModule} from "../image-editor/image-editor.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FileUploadModule,
        usersRouting,
        TooltipModule,
        DialogModule,
        MessagesModule,
        MessageModule,
        ImageEditorModule
    ],
    declarations: [
        UserListComponent,
        UserFormComponent
    ]
})

export class UsersModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/users/users.module.ts